import React from "react";
import { Box } from "@mui/system";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { formatHourRange, formatRainfallValue, twoDigitAfterDecimal } from "../../../../utils/helper";
import { InComponentLoader } from "../../../../library/common/Loader";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import IconButton from "@mui/material/IconButton";

const RainFallDataPerHour = (props) => {
  const hoursData = props?.hourData?.hours;
  const isLoading = props?.isLoading;
  const currentDate = props?.currentDate;
  
  const totalPrecipValue = hoursData?.reduce(
    (sum, hour) => sum + (hour?.precip_value || 0),
    0
  );

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr + "T00:00:00");
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const isNextDayDisabled = () => {
    if (!currentDate) return true;
    const current = new Date(currentDate + "T00:00:00");
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return current >= today;
  };

  return (
    <>
      <Modal
        open={props?.open}
        onClose={props?.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="caseSummaryModal"
      >
        <Grid className="modalContainer viewPast7RainFallModal">
          <Box className="modalBox width600">
            <div className="modalHeaderTitle"></div>
            <div className="modalHeader">
              <div className="modalHeaderClose" onClick={props?.handleClose}>
                X
              </div>
            </div>
            <div className="modalBody">
              <div className="dynamic-table">
                <div className="perHourHeader">
                  <h3>Per Hour Breakdown <strong>{"(Rounded)"}</strong></h3>
                  <div className="dayNavigation">
                    <IconButton
                      size="small"
                      onClick={props?.onPrevDay}
                      disabled={isLoading}
                      title="Previous Day"
                    >
                      <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>
                    <span className="currentDateLabel">
                      {formatDisplayDate(currentDate)}
                    </span>
                    <IconButton
                      size="small"
                      onClick={props?.onNextDay}
                      disabled={isLoading || isNextDayDisabled()}
                      title="Next Day"
                    >
                      <ArrowForwardIosIcon fontSize="small" />
                    </IconButton>
                  </div>
                </div>
                {isLoading ? (
                  <div className="loaderCenter">
                    <InComponentLoader />
                  </div>
                ) : hoursData && hoursData.length > 0 ? (
                  <div className="tableWrapper">
                    <div className="tableScrollArea">
                      <table>
                        <thead>
                          <tr>
                            <th>Time</th>
                            <th>NWS Data Missing</th>
                            <th>Rain Amount (Inches)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {hoursData.map((hour) => {
                            return (
                              <tr key={hour?.index}>
                                <td>{formatHourRange(hour?.index)}</td>
                                <td>{hour?.nws_data_missing ? "Yes" : "No"}</td>
                                <td>{formatRainfallValue(hour?.precip_value)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <table className="totalTable">
                      <tfoot>
                        <tr className="totalRow">
                          <td>Total</td>
                          <td></td>
                          <td>{formatRainfallValue(totalPrecipValue)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                ) : (
                  <div className="noRecordFound">No Record Found</div>
                )}
              </div>
            </div>
          </Box>
        </Grid>
      </Modal>
    </>
  );
};

export default RainFallDataPerHour;
